module.exports = __webpack_public_path__ + "static/media/filter_en.ec144b00.png";